import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import qs from 'qs'
Vue.prototype.$qs=qs

import router from './router';

import request from './api/request'
Vue.prototype.$http = request

Vue.config.productionTip = false

// 全局解析守卫
router.beforeResolve((to, from, next) => {
  window.document.title = to.meta.title
  next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
